import axios from 'axios'


const api = {
  methods:{
    async getReferenceLogs(projectId,reference_type){
      const token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
      axios.defaults.headers['x-csrf-token'] = token
      axios.defaults.headers.common['Accept'] = 'application/json';
      axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
      const path =  `/reference_logs?project_id=${projectId}&reference_type=${reference_type}`
      const result = await axios.get(path)

      return result.data
    }
  }  
}

export default api